import { useEffect, useState } from "react"

const LOADING_REGENERATE_INTERVAL = 1500 // 1.5 sec

export default function useChartLoadingDataForAnimation(
  isLoading: boolean,
  generateNewValues: () => unknown,
  interval = LOADING_REGENERATE_INTERVAL,
) {
  const [loadingData, setLoadingData] = useState(generateNewValues())

  const [intervalId, setIntervalId] = useState<ReturnType<
    typeof setInterval
  > | null>(null)

  useEffect(() => {
    if (isLoading && !intervalId) {
      const newIntervalId = setInterval(() => {
        const loadingData = generateNewValues()
        setLoadingData(loadingData)
      }, interval)
      setIntervalId(oldVal => {
        if (oldVal) {
          clearInterval(oldVal)
        }
        return newIntervalId
      })
    } else if (!isLoading && intervalId) {
      clearInterval(intervalId)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [isLoading, intervalId])

  return loadingData
}
